{
  "states": {
    "loading": "لوڈ ہو رہا ہے...",
    "unavailable": "--"
  },
  "button": {
    "defaultCity": "سان فرانسسکو"
  },
  "conditions": {
    "Clear": "صاف",
    "Clouds": "بادل",
    "Rain": "بارش",
    "Drizzle": "بوندا باندی",
    "Thunderstorm": "گرج چمک",
    "Snow": "برف باری",
    "Mist": "دھند",
    "Smoke": "دھواں",
    "Haze": "غبار",
    "Dust": "گرد",
    "Fog": "کہرا",
    "Sand": "ریت",
    "Ash": "راکھ",
    "Squall": "تیز جھکڑ",
    "Tornado": "بگولہ"
  },
  "modal": {
    "defaultTitle": "موسم",
    "subtitle": "موجودہ حالات",
    "showFahrenheit_aria": "فارن ہائیٹ دکھائیں",
    "showCelsius_aria": "سیلسیس دکھائیں",
    "switchToCelsius_title": "°C پر جائیں",
    "switchToFahrenheit_title": "°F پر جائیں",
    "feelsLike": "محسوس ہوتا ہے {{temp}}°{{unit}}",
    "humidityWind": "نمی {{humidity}}% · ہوا {{wind}}",
    "windSpeed": "{{speed}} میل فی گھنٹہ",
    "hourlyNow": "ابھی",
    "hourlyOffset": "{{hours}} گھنٹے",
    "hourlyStrip_aria": "گھنٹہ وار درجہ حرارت",
    "hourlyLocked": "گھنٹہ وار پیش گوئی ایک Pro خصوصیت ہے۔",
    "statsLocked": "موسم کی تفصیلات ایک Pro خصوصیت ہیں۔",
    "stats": {
      "sunrise": "طلوع آفتاب",
      "sunset": "غروب آفتاب",
      "feels": "محسوس",
      "humidity": "نمی",
      "wind": "ہوا",
      "rain": "بارش"
    },
    "rainInches": "{{value}} انچ",
    "forecastTitle": "5 روزہ پیش گوئی",
    "forecastLoading": "پیش گوئی لوڈ ہو رہی ہے…",
    "forecastUnavailable": "پیش گوئی دستیاب نہیں",
    "forecastLocked": "5 روزہ پیش گوئی ایک Pro خصوصیت ہے۔",
    "forecastRow_aria": "پانچ روزہ پیش گوئی",
    "proHeadline": "مکمل پیشن گوئی Pro کا حصہ ہے۔",
    "proFeatures": "ہر گھنٹہ · تفصیلی حالات · 5 دن کا جائزہ۔"
  }
}
